export const EXACT_MATCH_KEYWORD_PATTERN = /^"([^"]+)"$/;

export function extractQuotedKeyword(value: string | undefined): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  const quotedMatch = value.trim().match(EXACT_MATCH_KEYWORD_PATTERN);
  return quotedMatch ? quotedMatch[1] : null;
}
